import React, { useState } from "react";
import { Input } from "@amzn/awsui-components-react-v3/polaris";
import { useNavigate } from "react-router-dom";

const isValidAlias = (value: string) =>
  value.length >= 1 && value.length <= 10 && /^[a-zA-Z]+$/.test(value);

/**
 * Search bar component, currently for searching for users by their alias.
 */
export const SearchBar = () => {
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const trimmed = searchValue.trim();
  const showInvalid = trimmed.length > 0 && !isValidAlias(trimmed);

  const handleSearch = () => {
    if (trimmed && isValidAlias(trimmed)) {
      navigate(`/users/${trimmed}`);
      setSearchValue("");
    }
  };

  return (
    <Input
      type="search"
      placeholder="Search users by alias..."
      value={searchValue}
      invalid={showInvalid}
      onChange={({ detail }) => setSearchValue(detail.value)}
      onKeyDown={({ detail }) => {
        if (detail.key === "Enter") handleSearch();
      }}
      data-testid="search-input"
    />
  );
};
